import React from 'react'
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import BenConversation from './components/BenConversation/BenConversation'
import SEOHead from './components/SEOHead'

// Main page components
// import HeroSection from './components/HeroSection'
import HeroSectionNew from './components/HeroSectionNew'
import ServicesSection from './components/ServicesSection'
import WhyChooseUsSection from './components/WhyChooseUsSection'
import ResultsStrip from './components/ResultsStrip'
import TeamSection from './components/TeamSection'
import TestimonialsSection from './components/TestimonialsSection'
import ContactSection from './components/ContactSection'

// SEO Landing Pages
import SaphoriVsDhiPage from './components/SaphoriVsDhiPage'
import PrixGreffeComparaisonPage from './components/PrixGreffeComparaisonPage'
import TroisTechniquesPage from './components/TroisTechniquesPage'

// Feature Pages
import BenTV from './components/BenTV'
import BenTVTeaser from './components/BenTVTeaser'

// Legal Pages
import MentionsLegalesPage from './components/MentionsLegalesPage'
import PolitiqueConfidentialitePage from './components/PolitiqueConfidentialitePage'

// Home Page Component
const HomePage = () => {
  const homeSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "name": "Clinique du Grand Paris",
    "image": "https://bonjour.cliniquedugrandparis.com/og-image.jpg",
    "url": "https://bonjour.cliniquedugrandparis.com/",
    "telephone": "+33148662035",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "37A Avenue d'Iéna",
      "addressLocality": "Paris",
      "postalCode": "75116",
      "addressCountry": "FR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 48.8689,
      "longitude": 2.2928
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "opens": "10:00",
      "closes": "19:00"
    },
    "priceRange": "€€€",
    "medicalSpecialty": "PlasticSurgery"
  };

  return (
    <>
      <SEOHead
        title="Greffe de Cheveux Paris - SAPHORÏ®, CHOÏ, SAPHIR"
        description="Leader parisien de la greffe capillaire. 2000+ transformations réussies avec SAPHORÏ®, CHOÏ et SAPHIR. Diagnostic gratuit et résultats garantis. Paris 16ème."
        schema={homeSchema}
      />
      {/* Hero Section */}
      <HeroSectionNew />
      <ResultsStrip />
      <ServicesSection />
      <WhyChooseUsSection />
      <TeamSection />
      <BenTVTeaser />
      <TestimonialsSection />
      <ContactSection />
    </>
  )
}

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation()
  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}

// Layout wrapper for all pages
const Layout = ({ children }) => {
  return (
    <div className="App">
      <Header />
      <main>
        {children}
      </main>
      <Footer />
    </div>
  )
}

// Mount Ben once, above the router Outlet. BenTV has its own CTA and a dark
// theme, so the floating bubble is suppressed there; the conversation modal
// remains mountable via window.openBenChat.
const BenMount = () => {
  const { pathname } = useLocation()
  const hideBubble = pathname.startsWith('/ben-tv')
  return <BenConversation hideBubble={hideBubble} />
}

function App() {
  // Scroll Reveal Animation Logic
  React.useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal-visible');
          observer.unobserve(entry.target); // Only animate once
        }
      });
    }, observerOptions);

    const hiddenElements = document.querySelectorAll('.reveal-hidden');
    hiddenElements.forEach((el) => observer.observe(el));

    return () => {
      hiddenElements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Routes>
          {/* Home Page */}
          <Route path="/" element={
            <Layout>
              <HomePage />
            </Layout>
          } />

          {/* SEO Landing Pages */}
          <Route path="/saphori-vs-dhi-paris" element={
            <Layout>
              <SaphoriVsDhiPage />
            </Layout>
          } />

          <Route path="/prix-greffe-cheveux-techniques-comparees" element={
            <Layout>
              <PrixGreffeComparaisonPage />
            </Layout>
          } />

          <Route path="/3-techniques-vs-1-seule-methode" element={
            <Layout>
              <TroisTechniquesPage />
            </Layout>
          } />

          {/* Ben TV - Video Hub (standalone dark theme, no Layout wrapper) */}
          <Route path="/ben-tv" element={<BenTV />} />

          {/* Legal Pages */}
          <Route path="/mentions-legales" element={
            <Layout>
              <MentionsLegalesPage />
            </Layout>
          } />

          <Route path="/politique-confidentialite" element={
            <Layout>
              <PolitiqueConfidentialitePage />
            </Layout>
          } />

          {/* Catch all route - redirect to home */}
          <Route path="*" element={
            <Layout>
              <HomePage />
            </Layout>
          } />
        </Routes>
        <BenMount />
      </Router>
  )
}

export default App
